import { Vue, Component, Prop, Ref, Watch } from 'vue-property-decorator';
import { Keywords } from '@/visa-application/models/KeywordsCMSModel';
import _ from 'lodash';

interface SelectValue {
  value: string;
  title: string;
  id?: number | string;
}

@Component
export default class CustomSelect extends Vue {
  @Ref() readonly selectRef!: HTMLElement;
  @Prop() placeholder: string;
  @Prop() value!: SelectValue[];
  @Prop({ default: () => [] }) options!: SelectValue[];
  @Prop({ default: false }) showAllOption: boolean;

  @Watch('value', { immediate: true, deep: true })
  onValueChanged(newValue: SelectValue[]) {
    this.selected = this.options.map(option => !!newValue.find(val => val.value === option.value && val.id === option.id));
  }
  @Watch('selected', { deep: true })
  onSelectedChanged() {
    if (this.showAllOption) {
      this.selectAll = this.selected.every(value => value === true);
    }
  }
  @Watch('$store.getters.keywords', { immediate: true })
  public onKeywordsChanged(keywords: Keywords): void {
    this.keywords = keywords;
  }

  public keywords: Partial<Keywords> = {};
  public showDropdown = false;
  public selectAll = false;
  public selected: boolean[] = [];

  get selectedItems() {
    return this.options.filter((_, index) => this.selected[index]);
  }
  get selectedItemsText() {
    return this.selectedItems.map(item => item.title).join(', ');
  }

  public toggleDropdown() {
    if (this.options.length === 1) return;

    this.showDropdown = !this.showDropdown;
  }
  public updateSelection() {
    this.$emit('input', this.selectedItems);
  }
  public clickOutside(event: Event) {
    if (this.selectRef && !this.selectRef.contains(event.target as Node)) {
      this.showDropdown = false;
    }
  }
  public handleSelectAllChange() {
    this.selected = new Array(this.options.length).fill(this.selectAll);
    this.updateSelection();
  }

  mounted() {
    document.addEventListener('click', this.clickOutside);
    this.selected = new Array(this.options.length).fill(this.options.length === 1 ? true : false);
    this.updateSelection();
  }
  beforeDestroy() {
    document.removeEventListener('click', this.clickOutside);
  }
}
